import React, { useEffect, useState } from 'react';
import { Route, RouteComponentProps, useLocation } from 'react-router-dom';
import { IAlertModel, IProductGroup } from '../../models/LeadTimes';
import { ProductsLoadingDialog } from '../products-loading-dialog/ProductsLoadingDialog';
import ProductsCard from '../ProductsCard';
import ProductsProvider from '../ProductsContext';
import { useQuery } from '../../components/QueryParamHook';
import * as actions from '../redux/ProductsActions';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import LeadTimesImportModal from '../components/leadtimes-import-modal/LeadTimesImportModal';
import { usePlant } from '../../components/PlantHook';

interface Props {
  history: RouteComponentProps['history'];
}

const ProductGroupPage = (props: Props) => {
  const query = useQuery();
  const plantCode = usePlant();
  const dispatch = useDispatch();
  const { state } = useLocation<{ productGroup: IProductGroup }>();
  const [productGroupName, setProductGroupName] = useState<string>('');
  const [showImportModal, setShowImportModal] = useState(false);
  const [hasLeadTimesUpdated, setHasLeadTimesUpdated] = useState(false);
  const { alert } = useSelector(
    (state: any) => ({
      alert: (state.products?.error as IAlertModel) || null,
    }),
    shallowEqual
  );

  const productsUIEvents = {
  };

  const downloadLeadTimesHandler = async () => {
    await dispatch(
      actions.downloadLeadTimesPerProductGroup(plantCode, productGroupName)
    );
  };

  const showImportModalHandler = () => {
    setShowImportModal(true);
  };

  useEffect(() => {
    if (state?.productGroup.name) {
      setProductGroupName(state.productGroup.name);
    }
  }, [state?.productGroup.name]);

  return (
    <ProductsProvider
      productsUIEvents={productsUIEvents}
      productGroupName={state?.productGroup.name ?? productGroupName}
    >
      <LeadTimesImportModal
        show={showImportModal}
        setShowImportModal={setShowImportModal}
        setHasLeadTimesUpdated={setHasLeadTimesUpdated}
        plantCode={plantCode}
        canScheduleLeadTimes={true}
      />
      <ProductsLoadingDialog />
      <ProductsCard
        leadTimesAlert={alert}
        downloadLeadTimesHandler={downloadLeadTimesHandler}
        showImportModalHandler={showImportModalHandler}
        hasLeadTimesUpdated={hasLeadTimesUpdated}
      />
    </ProductsProvider>
  );
};

export default ProductGroupPage;
